import { useMediaQuery } from "react-responsive";

// 메인페이지(질문페이지) 미디어쿼리
// max-width, min-width 둘 다포함
const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1141, maxWidth: 10000 });
  return isDesktop ? children : null;
};

// const Tablet = ({ children }) => {
//   const isTablet = useMediaQuery({ minWidth: 600, maxWidth: 1199 });
//   return isTablet ? children : null;
// };

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 1140 });
  return isMobile ? children : null;
};

// export { Desktop, Tablet, Mobile };
export { Desktop, Mobile };

/*
Desktop / 1920-1141
Tablet / 1140-600
Mobile / 599-320
*/

//  /* Desktops / 1920-1141 */
// @media (max-width: 1920px) and (min-width: 1141px) {
//   }

// /* Tablet / 1140-600 */
// @media (max-width: 1140px) and (min-width: 600px) {
// }

// /* Mobile / 599-320 */
// @media (max-width: 599px) and (min-width: 320x) {
// }
